/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const businessModelGoToMarketDtoSchema = z.object({
  strategy: z.optional(z.string()),
  lead: z.optional(z.string()),
  target: z.optional(z.string()),
  motion: z.optional(z.string()),
  rationale: z.optional(z.string()),
});
